<template>
    <page :title="title" :breadcrumb="breadcrumb">
        <div>
            <div class="progress-steps" v-if="!recreation">
                <div class="row">
                    <div class="col-sm-3 col-md-3">
                        <p class="progress-step done">
                            <i class="fa fa-check"></i>
                            <span class="title">{{ $t('reservation_selectCampsite') }}</span>
                        </p>
                    </div>
                    <div class="col-sm-3 col-md-3">
                        <p class="progress-step done">
                            <i class="fa fa-bookmark"></i>
                            <span class="title">{{ $t('reservation_reservation') }}</span>
                        </p>
                    </div>
                    <div class="col-sm-3 col-md-3">
                        <p class="progress-step done">
                            <i class="fa fa-list"></i>
                            <span class="title">{{ $t('reservation_summary') }}</span>
                        </p>
                    </div>
                    <div class="col-sm-3 col-md-3">
                        <p :class="{'progress-step':true, 'active':!success, 'done':success}">
                            <i class="fa fa-shopping-cart"></i>
                            <span class="title">{{ $t('reservation_checkout') }}</span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="progress-steps" v-else>
                <div class="row" >
                    <div class="col-sm-3 col-md-3">
                        <p class="progress-step done">
                            <i class="fa fa-list"></i>
                            <span class="title">{{ $t('reservation_summary') }}</span>
                        </p>
                    </div>
                    <div class="col-sm-3 col-md-3">
                        <p :class="{'progress-step':true, 'active':!success, 'done':success}">
                            <i class="fa fa-shopping-cart"></i>
                            <span class="title">{{ $t('reservation_checkout') }}</span>
                        </p>
                    </div>
                </div>
            </div>
            <template v-if="!recreation">
                <div class="form-group" v-if="!success && booking !== null">
                    <h3>{{ $t('payment_failed', {amount: booking.totalamountincludingtax} ) }}</h3>
                    <button class="btn btn-primary btn-block" @click="pay()">
                        <i class="fa fa-credit-card" aria-hidden="true"></i>
                        {{ $t('retry_payment') }}
                    </button>
                </div>
                <div v-else>
                    <div class="row">
                        <div class="col-md-4">
                            <img v-if="campsite !== null && campsite.mainimage" class="paymentImage"
                                 :title="campsite.mainimage.name"
                                 :src="campsite.mainimage.source"/>
                        </div>
                        <div class="col-md-8">
                            <h2>{{ $t('payment_successful', {campsitename: booking.campsitename, from:
                                booking.arrivaldate,
                                to: booking.departuredate}) }}</h2>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="form-group" v-if="!success">
                    <h3>{{ $t('payment_failed', {amount: amount} ) }}</h3>
                    <button class="btn btn-primary btn-block" @click="pay()">
                        <i class="fa fa-credit-card" aria-hidden="true"></i>
                        {{ $t('retry_payment') }}
                    </button>
                </div>
                <div class="row" v-if="success">
                    <div class="col-md-4">
                        <img v-if="campsite !== null && campsite.mainimage" class="paymentImage"
                             :title="campsite.mainimage.name"
                             :src="campsite.mainimage.source"/>
                    </div>
                    <div class="col-md-8">
                        <h2>{{ $t('recreation_payment_successful', {campsitename: campsite.campsitename}) }}</h2>
                    </div>
                </div>
            </template>
        </div>
    </page>
</template>

<script>
import { API, setAuthorizationToken } from '../api/axios'
import Page from './utilities/Page'
import { mapGetters, mapMutations } from 'vuex'
import { campsiteHelper } from '@/mixins/campsiteHelperMixin'

export default {
  name: 'Payment',
  components: { Page },
  mixins: [campsiteHelper],
  props: {
    mode: {
      type: String,
      default: 'campsite',
    },
  },
  data () {
    return {
      status: null,
      booking: null,
      campsite: null,
      amount: null,
    }
  },
  computed: {
    ...mapGetters(['reservation', 'language', 'user', 'savedQueryParams']),
    recreation () {
      return this.mode === 'recreation'
    },
    success () {
      return this.status === 'Ok'
    },
    breadcrumb () {
      return [
        // {
        //   name: 'Listings',
        //   query: this.savedQueryParams
        // },
        // {
        //   name: 'Detail',
        //   params: {lang: this.language, id: this.reservation.campsiteid},
        //   display: this.reservation.campsitename,
        // },
      ]
    },
    title () {
      return this.success ? this.$t('checkout_successfulPayment') : this.$t('checkout_failedPayment')
    },
  },
  methods: {
    ...mapMutations(['setJail', 'hideFooter']),
    link (to) {
      this.$router.push({ name: to, params: { lang: this.language } })
    },
    pay () {
      this.setAuthCookie(this.user.token)
      if (this.recreation) {
        API.get(`/shoppingcart/lang/${this.language}/${this.$route.params.sessionid}/retry`)
          .then(response => {
            window.location.href = response.data.checkouturl
          })
      } else {
        API.get(`/payment/retry/lang/${this.language}/id/${this.$route.params.transaction}`)
          .then(response => {
            window.location.href = response.data.checkouturl
          })
      }
    },
  },
  created () {
    if (this.recreation) {
      this.hideFooter(true)
      this.setJail(true)
    }
    // this.$store.commit('changeUserData', response.data)
    let authToken = this.getAuthCookie()
    if (authToken !== null) {
      API.get(`/users/token/${authToken}`)
        .then(response => {
          this.$store.commit('changeUserData', response.data)
        })
      setAuthorizationToken(this.getAuthCookie())
    }
    if (this.recreation) {
      API.get(`/shoppingcart/${this.$route.params.sessionid}/result`)
        .then(response => {
          this.status = response.data.Status
          this.amount = response.data.Amount

          API.get(`/campsites/${response.data.Vouchers[0].campsiteid}?languageId=${this.language}`)
            .then(response => {
              this.campsite = response.data.campsitelist[0]
            })
        })
    } else {
      API.get(`/payment/result/id/${this.$route.params.transaction}`)
        .then(response => {
          this.status = response.data.Status
          this.booking = response.data.Booking

          API.get(`/campsites/${this.booking.campsiteid}?languageId=${this.language}`)
            .then(response => {
              this.campsite = response.data.campsitelist[0]
            })
        })
    }
  },
}
</script>

<style scoped>
    .paymentImage {
        width: 100%
    }
</style>



// WEBPACK FOOTER //
// src/components/Payment.vue